import React from "react"

export const Footer = () => {
  return (
    <>
      <footer>
        <p>Powered by Fatma Ben Aissa .</p>
      </footer>
    </>
  )
}
